import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface ArticleCardProps {
  id: string;
  title: string;
  category: string;
  author: string;
  date: string;
  summary: string;
  coverImage: string;
  tags: string[];
  readTime: string;
}

export default function ArticleCard({ id, title, category, author, date, summary, coverImage, tags, readTime }: ArticleCardProps) {
  const catInfo = categories.find((c) => c.slug === category);

  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <div className="relative overflow-hidden aspect-[2/1] bg-background-200">
        <img
          src={coverImage}
          alt={title}
          title={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {catInfo && (
          <span className="absolute top-3 left-3 bg-primary-500 text-background-50 dark:text-foreground-950 text-xs font-medium px-2.5 py-1 rounded-full">
            {catInfo.name}
          </span>
        )}
      </div>
      <div className="p-4 md:p-5">
        <h3 className="font-heading font-semibold text-foreground-900 text-base group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
          {title}
        </h3>
        <p className="text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
          {summary}
        </p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 text-xs text-foreground-400">
            <span>{author}</span>
            <span>·</span>
            <span>{date}</span>
          </div>
          <span className="text-xs text-foreground-400">{readTime}</span>
        </div>
        {tags.length > 0 && (
          <div className="flex items-center gap-1.5 mt-3 flex-wrap">
            {tags.slice(0, 3).map((tag) => (
              <span key={tag} className="text-xs bg-secondary-100 text-secondary-600 px-2 py-0.5 rounded-full">
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}